import { AxiosRequestConfig } from 'axios';

import { postRequest } from '@services/RequestService';

interface FileMetadata {
  name: string | null | undefined;
  type: string;
}

export const uploadToS3 = (
  type: any,
  file: Blob,
  metadata: FileMetadata,
// eslint-disable-next-line no-async-promise-executor
) => new Promise(async (resolve, reject) => {
  const filename = metadata.name;
  const fileType = metadata.type;
  // generate s3 url first
  try {
    const response = await postRequest(`upload/generate/${type}`, {
      filename,
      fileType,
    }, {}).$promise;
    if (!response) {
      reject(new Error('No response'));
      return;
    }

    // Phase 3 (backend): now answers {data: {url, filename}} instead of it directly.
    const result = response.data?.data;

    // we're using fetch to remove connection with our api
    await fetch(result.url, {
      method: 'PUT',
      body: file,
    });
    // return the filename if uploading with s3 is successful
    resolve(result.filename);
  } catch (e) {
    reject(e);
  }
});

export const uploadFileArr = (
  type: any,
  files: any,
  // eslint-disable-next-line no-async-promise-executor
) => new Promise(async (resolve, reject) => {
  const filename: any = [];
  const fileType: any = [];
  const fileSize: any = [];
  files.forEach((f: any) => {
    filename.push(f.name);
    fileType.push(f.type);
    fileSize.push(f.size);
  });
  // generate s3 url first
  try {
    const response = await postRequest(`upload/generate/${type}/multiple`, {
      filename,
      fileType,
      fileSize,
    }, {}).$promise;

    if (!response) {
      reject(new Error('No response'));
      return;
    }

    // Phase 3 (backend): now answers {data: [...]} instead of the array directly.
    const result = response.data?.data;

    // map file object to the response of generated urls and use it in uploading to s3
    const newResult = result.map((res: any) => {
      files.map((file: any) => {
        if (file.name === res.originalFilename) {
          res.file = file;
        }
        return file;
      });
      return res;
    });

    // we're using fetch to remove connection with our api
    // await fetch(result.url, {
    //   method: 'PUT',
    //   body: file,
    // });

    // const promises = result.map(e => fetch(e.url, {
    //   method: 'PUT',
    //   body: e.file,
    // }));
    // await Promise.all(promises);

    // newResult.map((e) => {
    //   // if the file does not have a url, means it has an error while generating a url
    //   if (!e.url) {
    //     const res = {
    //       status: 400,
    //     };
    //     // const event = {
    //     //   total: 100,
    //     // };
    //     onResponse(res, e);
    //     // loader(event, e);
    //     return false;
    //   }
    //   const xhr = new XMLHttpRequest();
    //   // xhr.upload.addEventListener('progress', (event) => {
    //   //   loader(event, e);
    //   //   // const percent = Math.round((event.loaded / event.total) * 100);
    //   // });

    //   xhr.open('PUT', e.url);
    //   try {
    //     xhr.onreadystatechange = function () {
    //       // readyState === 4 means the request is done
    //       if (xhr.readyState === 4) {
    //         if (xhr.status === 200) {
    //           onResponse(xhr, e);
    //         } else {
    //           onResponse(xhr, e);
    //         }
    //       }
    //     };
    //     xhr.send(e.file);
    //   } catch (error) {
    //     // throw new Error(`Failed to upload file ${file.name}.`);
    //     reject(new Error('Failed to upload file'));
    //   }
    //   return true;
    // });

    // return the filename if uploading with s3 is successful
    resolve(newResult);
  } catch (e) {
    reject(e);
  }
});

export default function uploadToServer(
  url: string, name: string, file: File, config: AxiosRequestConfig,
) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append(name, file);

    try {
      const response = await postRequest(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        ...config,
      }).$promise;
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}
